import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@purespectrum1/ui/button';
import { SelectDropdownModule } from '@purespectrum1/ui/select-dropdown';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TableCaptionDirective } from './directives/table-caption.directive';
import { TableCellTemplateDirective } from './directives/table-cell-template.directive';
import { TableCheckboxColumnDirective } from './directives/table-checkbox-column.directive';
import { TableColumnCustomHeaderDirective } from './directives/table-column-custom-header.directive';
import { TableColumnFilterDirective } from './directives/table-column-filter.directive';
import { TableColumnHeaderOptionDirective } from './directives/table-column-header-option.directive';
import { TableColumnDirective } from './directives/table-column.directive';
import { TableExpandableContentDirective } from './directives/table-expandable-content.directive';
import { TableExpandableRowDirective } from './directives/table-expandable-row.directive';
import { TableColumnHeaderComponent } from './table-column-header/table-column-header.component';
import { TableComponent } from './table/table.component';
import { TableColumnFooterDirective } from './directives/table-column-footer.directive';
import { LongPressDirective } from './directives/long-press.directive';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    InfiniteScrollModule,
    SelectDropdownModule,
    ButtonModule,
    ReactiveFormsModule,
  ],
  declarations: [
    TableComponent,
    TableColumnDirective,
    TableColumnHeaderComponent,
    TableColumnHeaderOptionDirective,
    TableColumnCustomHeaderDirective,
    TableCheckboxColumnDirective,
    TableCellTemplateDirective,
    TableExpandableRowDirective,
    TableExpandableContentDirective,
    TableColumnFilterDirective,
    TableColumnFooterDirective,
    TableCaptionDirective,
    LongPressDirective,
  ],
  exports: [
    TableComponent,
    TableColumnDirective,
    TableColumnHeaderComponent,
    TableColumnHeaderOptionDirective,
    TableColumnCustomHeaderDirective,
    TableCheckboxColumnDirective,
    TableCellTemplateDirective,
    TableExpandableRowDirective,
    TableExpandableContentDirective,
    TableColumnFilterDirective,
    TableColumnFooterDirective,
    TableCaptionDirective,
    LongPressDirective,
  ],
  providers: [],
})
export class TableModule {}
